(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-description-truncate"] && !Shopify.designMode) return;
  try {
    class ProductDescriptionTruncate extends HTMLElement {
		connectedCallback() {
			this._content = this.querySelector('.product-description-truncate__content')
			this._toggle = this.querySelector('.product-description-truncate__toggle')
			this._toggleText = this.querySelector('.product-description-truncate__toggle-text')

			if (!this._content || !this._toggle || !this._toggleText) {
				return
			}

			this._maxLines = parseInt(this.getAttribute('max-lines') || '8', 10)
			this._viewMore = this.getAttribute('data-view-more') || 'View more'
			this._viewLess = this.getAttribute('data-view-less') || 'View less'
			this._expanded = false

			this._content.style.setProperty('--line-clamp-count', this._maxLines)

			this._toggle.addEventListener('click', this._onToggle.bind(this))

			this._resizeObserver = new ResizeObserver(() => {
				if (!this._expanded) {
					this._measure()
				}
			})
			this._resizeObserver.observe(this._content)

			if (document.fonts?.ready) {
				document.fonts.ready.then(() => this._measure())
			}

			this._measure()
		}

		disconnectedCallback() {
			this._resizeObserver?.disconnect()
		}

		_getLineHeight(element) {
			const lineHeight = parseFloat(getComputedStyle(element).lineHeight)

			if (!Number.isNaN(lineHeight)) {
				return lineHeight
			}

			const probe = document.createElement('span')
			probe.textContent = 'A'
			probe.style.visibility = 'hidden'
			probe.style.position = 'absolute'
			element.appendChild(probe)
			const height = probe.getBoundingClientRect().height
			probe.remove()
			return height || 16
		}

		_clearTruncate() {
			this._content.classList.remove('truncate')
		}

		_applyTruncate() {
			this._content.classList.add('truncate')
		}

		_setToggleVisible(visible) {
			this._toggle.hidden = !visible
		}

		_needsTruncate() {
			this._clearTruncate()

			const lineHeight = this._getLineHeight(this._content)
			const maxHeight = lineHeight * this._maxLines

			if (this._content.scrollHeight <= maxHeight + 1) {
				return false
			}

			this._applyTruncate()
			return this._content.scrollHeight > this._content.clientHeight + 1
		}

		_measure() {
			if (this._expanded) {
				this._setToggleVisible(true)
				return
			}

			const needsTruncate = this._needsTruncate()

			this._setToggleVisible(needsTruncate)

			if (!needsTruncate) {
				this.classList.remove('is-truncated', 'is-expanded')
				this._toggle.setAttribute('aria-expanded', 'false')
				return
			}

			this.classList.add('is-truncated')
			this.classList.remove('is-expanded')
			this._toggleText.textContent = this._viewMore
			this._toggle.setAttribute('aria-expanded', 'false')
		}

		_onToggle() {
			this._expanded = !this._expanded

			if (this._expanded) {
				this._clearTruncate()
				this.classList.add('is-expanded')
				this.classList.remove('is-truncated')
				this._setToggleVisible(true)
				this._toggleText.textContent = this._viewLess
				this._toggle.setAttribute('aria-expanded', 'true')
				return
			}

			this._measure()
		}
	}

	if (!window.customElements.get('product-description-truncate')) {
		window.customElements.define('product-description-truncate', ProductDescriptionTruncate)
	}
  } catch(e) { console.error(e); }
})();

})();
